import {Carteira} from "../carteira/carteira.model";
import {Regra} from "../regra/regra";
import {TipoExecucao} from "./resultado-regra/tipo-execucao";

export class ResultadoRegra {
    id: number;
    carteira: Carteira;
    regra: Regra;
    dataEnquadramento: string;
    status: string;
    mensagem: string;
    timeStamp: string;
    subregras: ResultadoRegra[];
    tipoExecucao: string;
}
